import React from 'react'
import { CCard } from '@coreui/react'
import underConstructionImage from '../../../assets/underConstructionImage.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

const ServiceNotAllowed = ({ name, title }) => {
  return (
    <>
      <h4>{name}</h4>
      <p>{title}</p>
      <CCard
        style={{
          minHeight: '70vh',
          backgroundImage: `url(${underConstructionImage})`,
        }}
        className="blurImage-underConstruction"
      />
      <div className="text-underConstruction">
        <FontAwesomeIcon icon={faLock} className="mx-2" size="4x" />
        <p>This Service is not available in your Current Plan.</p>
        <p>Please Reach out to sales@ottdock.com</p>
      </div>
    </>
  )
}

export default ServiceNotAllowed
